export default "<input type=file [accept]=\"accept\" [multiple]=\"multiple\" (change)=\"fileAdd($event)\">";